<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Tarifs</h2>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12" v-for="service in  services " v-bind:key="service.id">
                    <div class="container">
                        <p v-html="service.content" class="contentclassService"></p>
                        <div class="row">
                            <div class="col-lg-4" v-if="service.image">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + service.image"
                                :alt="'Tarif au refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>

                            <div class="col-lg-4" v-if="service.image2">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + service.image2"
                                :alt="'Tarif au refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>

                            <div class="col-lg-4" v-if="service.image3">
                            <img
                                :src="'https://admin.asso-refuge.fr/images/' + service.image3"
                                :alt="'Tarif au refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence'"
                                style="display: block; margin-left: auto; margin-right: auto; width: 100%;"
                            />
                            </div>
                    </div>
                </div>
            </div>
            </div>

        </div>

</template>

<style src="../assets/css/besoins.css"></style>
<script>
export default {
    data() {
        return {
            services: [],
        };
    },
    mounted() {
        const idSite = this.$idSite;
        fetch(`https://admin.asso-refuge.fr/getServices/${idSite}`)
            .then(response => response.json())
            .then(data => {
                const formattedServices = data.map(service => ({
                    ...service,
                }));
                this.services = formattedServices;
            })
            .catch(error => {
                console.error('Il y a eu un problème avec votre requête :', error.message);
            });
    }
};

</script>
